import { __assign } from "tslib";
import { schema } from 'normalizr';
import { userSchema, userListSchema } from './user';
import { DeviationResourceType } from '../../../types/deviation';
var getCompositeId = function (typeId, deviationId) {
    return typeId === DeviationResourceType.ART
        ? deviationId
        : typeId + "-" + deviationId;
};
var makeDeviationId = function (value) {
    return getCompositeId(value.typeId, value.deviationId);
};
var processStrategy = function (value) {
    return __assign(__assign({}, value), { entityId: makeDeviationId(value) });
};
var deviationSchema = new schema.Entity('deviation', {
    author: userSchema,
}, {
    idAttribute: makeDeviationId,
    processStrategy: processStrategy,
});
var deviationListSchema = [deviationSchema];
// #region extended deviation
var collectionListSchema = new schema.Array({
    collection: { owner: userSchema, thumb: deviationSchema },
    deviations: deviationListSchema,
});
var deviationExtendedSchema = new schema.Entity('deviationExtended', {
    relatedStreams: {
        gallery: deviationListSchema,
        recommended: deviationListSchema,
        collections: collectionListSchema,
        groups: userListSchema,
        recent: deviationListSchema,
        popular: deviationListSchema,
        morePolls: deviationListSchema,
        latestStatus: deviationListSchema,
        moreLiterature: deviationListSchema,
        moreJournals: deviationListSchema,
        // these are generated
        recommendedJournals: deviationListSchema,
        recommendedLiterature: deviationListSchema,
        loveSuggestion: {
            deviations: deviationListSchema,
        },
    },
}, {
    idAttribute: function (value, parent, key) {
        return getCompositeId(parent.typeId, parent.deviationId);
    },
    processStrategy: function (value, parent, key) { return (__assign(__assign({}, value), { parentDeviationEntityId: getCompositeId(parent.typeId, parent.deviationId) })); },
});
// add extended to the deviation schema...
deviationSchema.define({ extended: deviationExtendedSchema });
// #endregion
export { deviationSchema, deviationListSchema, deviationExtendedSchema, makeDeviationId, getCompositeId, };
//# sourceMappingURL=deviation.js.map